/* Dateien aus einem Drop einsammeln, auch Ordner (mit relativem Pfad). Die Einträge der Browser-API werden nur über ihre
 * Methoden angesprochen, damit sich die Rekursion ohne DOM prüfen lässt. */

export interface PickedFile { file: File; rel: string }

interface Entry {
  isFile: boolean; isDirectory: boolean; name: string;
  file?(ok: (f: File) => void, err: (e: unknown) => void): void;
  createReader?(): { readEntries(ok: (es: Entry[]) => void, err: (e: unknown) => void): void };
}

const readAll = async (dir: Entry): Promise<Entry[]> => {
  const reader = dir.createReader!(), out: Entry[] = [];
  for (;;) {   // readEntries liefert höchstens ein Stück pro Aufruf, bis es leer ist
    const part = await new Promise<Entry[]>((ok, err) => reader.readEntries(ok, err));
    if (!part.length) return out;
    out.push(...part);
  }
};

async function walk(e: Entry, prefix: string, out: PickedFile[]): Promise<void> {
  if (e.isFile && e.file) {
    const file = await new Promise<File>((ok, err) => e.file!(ok, err));
    out.push({ file, rel: prefix + e.name });
  } else if (e.isDirectory && e.createReader) {
    for (const c of await readAll(e)) await walk(c, prefix + e.name + '/', out);
  }
}

/** Alle Dateien eines Drops: Ordner werden durchlaufen, rel ist der Pfad ab dem abgelegten Ordner (einzelne Dateien: nur der Name) */
export async function collectDropped(dt: { items?: ArrayLike<{ kind: string; webkitGetAsEntry?(): Entry | null; getAsFile(): File | null }>; files?: ArrayLike<File> }): Promise<PickedFile[]> {
  const out: PickedFile[] = [];
  const items = dt.items ? Array.from(dt.items) : [];
  // Einträge müssen sofort (synchron) abgeholt werden, bevor der Drop-Vorgang endet
  const entries = items.filter((i) => i.kind === 'file').map((i) => ({ entry: i.webkitGetAsEntry ? i.webkitGetAsEntry() : null, file: i.getAsFile() }));
  if (entries.some((x) => x.entry)) {
    for (const x of entries) {
      if (x.entry) await walk(x.entry, '', out);
      else if (x.file) out.push({ file: x.file, rel: x.file.name });
    }
    return out;
  }
  return Array.from(dt.files || []).map((f) => ({ file: f, rel: f.name }));
}
